export const roundoffAmount = (amount)=>{
    return Math.round(amount)
}